import { CoursesViewAdministered } from 'components/courses';

const HomeAdminContent = () => (
  <CoursesViewAdministered
    hideIfNoData={true}
    isHomeView={true}
    limitPerPage={4}
    showAllLinkHref="/courses?type=administered"
    titleShowCount={false}
  />
);

export default HomeAdminContent;
